import React from 'react';
import { RouteObject } from 'react-router-dom';
import { UserDetailsPage, UsersPage } from './views';

export const routes: RouteObject[] = [
  { path: 'users', element: <UsersPage /> },
  { path: 'users/:userId', element: <UserDetailsPage/> }
];

export default routes;